import { createFileRoute } from '@tanstack/react-router'
import { ClientWrapperPage } from '@/features/verifications'

interface VerifySearch {
  /** Invite token from the SMS deep-link. */
  token?: string
}

/**
 * `/verify` — public, no-login client wrapper opened from the SMS invite.
 * Client identity is fetched server-side from the token (`GET /kyc/checks/me`),
 * so the URL only needs to carry the token.
 */
export const Route = createFileRoute('/verify')({
  validateSearch: (search: Record<string, unknown>): VerifySearch => ({
    token: typeof search.token === 'string' ? search.token : undefined,
  }),
  component: VerifyRoute,
})

function VerifyRoute() {
  const { token } = Route.useSearch()
  return <ClientWrapperPage token={token} />
}
